<template>
    <div class="promotionContainer">
        <div id="tabContainer">
            <van-tabs v-model="active" :ellipsis="false" @click-tab="onClickTab">
                <van-tab v-for="(item, index) in tabList" :key="index" :title="$t(item.name)" :name="item.id">
                </van-tab>
            </van-tabs>
        </div>

        <div class="tab-content-wrapper" ref="contentWrapper">
            <!-- Events -->
            <div v-if="selectedTabID == 0" style="padding-bottom: 100px;">
                <div v-for="(item, index) in dataSet?.promotionList" :key="index">
                    <PromotionCard v-if="isShowCard(item.name)" :itemData="item"
                        :un-claimed-count="activityCount(userStore.unreadActivityMsgList, item?.id)"
                        @openAgentPopup="openAgentPopup" @openPWA="openPWAPopup" />
                </div>
            </div>
            <!-- Rule -->

            <!-- Rebate -->

            <!-- VIP -->
            <div v-if="selectedTabID == 3" style="padding-bottom: 100px;">
                <VipView :is-tab-view="true" />
            </div>
            <!-- Redeem code -->
            <div v-if="selectedTabID == 4" style="padding-bottom: 100px;">
                <GiftCodeView :is-tab-view="true" />
            </div>
            <!-- History -->
            <div v-if="selectedTabID == 5" style="padding-bottom: 100px;">
                <FundHistory :is-tab-view="true" />
            </div>

            <!-- Pending -->
        </div>
        <div v-if="userStore.footerComponent">
            <MainFooter :itemData="userStore.footerComponent" :active-footer="1" />
        </div>
    </div>
    <PwaAntiBlockingPopup ref="pwaPopupRef" />
    <PwaStatusPopup ref="pwaPopupStatusRef" />
</template>


<script setup lang="ts">
import { computed, PropType, ref, watch } from 'vue'
import PromotionCard from './components/promotionCardNew.vue'
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user';
import { activityCount, PromotionData, TAB_LIST } from '@/view/promotion/supporrtScript';
import GiftCodeView from '@/view/giftCode/giftCodeView.vue';
import VipView from '@/view/vip/vipView.vue';
import MainFooter from '../components/common/mainFooter.vue';
import { useRouter } from 'vue-router';
import PwaAntiBlockingPopup from '../components/common/pwaAntiBlockingPopup.vue';
import PwaStatusPopup from '../components/common/pwaStatusPopup.vue';
import FundHistory from '@/view/fundHistory/fundHistory.vue';
const userStore = useUserStore()
const router = useRouter()
const { t } = useI18n();
const active = ref(0)
const selectedTabID = ref(0)
const tabList = ref(TAB_LIST)
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const props = defineProps({
    dataSet: {
        type: Object as PropType<PromotionData>,
        required: true
    }
})
const contentWrapper = ref<HTMLElement | null>(null);
const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})

const emits = defineEmits(["openAgentPopup", "openPWAPopup", 'update:show'])

const openAgentPopup = () => {
    router.push('/agent')
}

const openPWAPopup = () => {
    emits("openPWAPopup")
}
const onClickTab = (data: any) => {
    selectedTabID.value = data.name
}
const isShowCard = (name: string) => {
    if (name === 'pwa_reward') {
        const hasPwaInfo = userStore.PWAConvertData
        if (hasPwaInfo) {
            return true
        } else {
            return false
        }

    } else {
        return true
    }
}
const pwaPoupOpen = () => {
    pwaPopupRef.value.open()
}

const pwaStatusPoupOpen = (title: string) => {
    pwaPopupStatusRef.value.open(title);
}
watch(() => selectedTabID.value, () => {
    if (contentWrapper.value) {
        contentWrapper.value.scrollTop = 0; // Reset local scroll to top
    }
});
defineExpose({
    pwaPoupOpen,
    pwaStatusPoupOpen
})
</script>
<style scoped>
.promotionContainer {
    /* padding-bottom: 100px; */
}

.card_list {
    padding: 10px 25px;
}

.header_col {
    color: #ffffffa6;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
}

.tab-content-wrapper {
    height: calc(100vh - 65px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
}

.tab-content-wrapper:-webkit-scrollbar {
    display: none;
}

#tabContainer>>>.van-tabs__nav {
    background: rgb(0, 32, 32);

}

#tabContainer>>>.van-tab:hover {
    background: #ffffff07;
}

#tabContainer>>>.van-tab {
    color: rgba(255, 255, 255, 0.39);
    font-size: 15px;
    font-weight: 600;
}

#tabContainer>>>.van-tabs__nav--line.van-tabs__nav--complete {
    padding: 0;
}

#tabContainer>>>.van-tab.van-tab--active {
    color: rgb(14, 177, 175);
    font-weight: 700;
    border-bottom: rgb(14, 177, 175) 3px solid;
}

::v-deep #tabContainer .van-tabs__wrap {
    position: fixed !important;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    background: rgb(0, 32, 32);
    height: 65px !important;
}

#tabContainer {
    padding-top: 65px;
}

::v-deep #tabContainer .van-tabs__nav {
    background: rgb(0, 32, 32);
}

#tabContainer>>>.van-tabs__line {
    background: transparent;
}

:deep(.van-tabs__wrap),
:deep(.van-tabs__scroll),
:deep(.van-tabs__nav),
:deep(.van-tabs__nav--line),
:deep(.van-tab) {
    scrollbar-width: none !important;
    /* Firefox */
}

:deep(.van-tabs__wrap::-webkit-scrollbar),
:deep(.van-tabs__scroll::-webkit-scrollbar),
:deep(.van-tabs__nav::-webkit-scrollbar),
:deep(.van-tabs__nav--line::-webkit-scrollbar),
:deep(.van-tab::-webkit-scrollbar) {
    display: none !important;
    /* Chrome, Safari, Edge */
}

#tabContainer>>>.van-tabs__line {
    bottom: 0px !important;
    width: 15% !important;
    height: 2px !important;
}

@media (max-width: 400px) {
    #tabContainer>>>.van-tab {
        font-size: 14px;
    }

    ::v-deep #tabContainer .van-tabs__wrap {
        height: 55px !important;
    }
}
</style>